export const palette = {
  primary: {
    main: "#3b331c",
  },
  secondary: {
    main: "#1B1934",
  },
  background: {
    paper: "#13082A",
    default: "",
  },
  text: {
    primary: "#ffffff",
  },
  divider: "#63B5E4",
};
